export const mapInitialValues = (initialValues, brandUid) => {
  const mappedInitialValues = {
    ...initialValues,
    brand_uid: brandUid || '',
    uid: initialValues?.uid || undefined,
    name: initialValues?.name || '',
    full_domain: initialValues?.full_domain || '',
    subdomain: initialValues?.full_domain?.split('.')?.[0] || '',
    base_currency: initialValues?.base_currency || '',
    base_language: initialValues?.base_language || '',
  };

  return mappedInitialValues;
};
